<script>
export default {
  name: 'odemeTalepListItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    rejectRecord(id) {
      this.$emit('rejectRecord', id);
    },
    approveRecord(id) {
      this.$emit('approveRecord', id);
    },
    openSaveDialog(item) {
      this.$emit('details', item);
    },
  },
};
</script>

<template>
  <tr>
    <td><b> {{ item.proje }}</b> <br/>{{ item.tur }} - {{item.pfaaliyet}} {{item.seviye}}.Seviye Onay</td>
    <td @click="openSaveDialog(item)" style="cursor:pointer"> {{ item.konu }} </td>
    <td> {{ item.tedarikci }}</td>
    <td> {{ item.ldTutar|toCurrency }} {{item.doviz}}</td>
    <td> {{ item.birSeviyeOnay}}</td>
    <td>
      <v-btn @click="rejectRecord(item.pfaaliyet)" color="darken-3" small icon fat text>
        <v-icon color="red">
          mdi-close
        </v-icon>
      </v-btn>
    </td>
    <td>
      <v-btn @click="approveRecord(item.pfaaliyet)" color="darken-3" small icon fat text>
        <v-icon color="success">
        mdi-check
      </v-icon>
      </v-btn>
    </td>
  </tr>
</template>
